import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import Toptitle from "../../components/toptitle"

const Construct = () => (
  <Layout>
    <SEO title="採用情報" />
    <div>
      <section className="mx-8 lg:mr-0 lg:ml-auto lg:w-2/3">
        <Toptitle>Sales</Toptitle>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <div className="relative left-1/2 right-1/2 w-screen -translate-x-1/2 lg:static lg:left-auto lg:right-auto lg:w-full lg:translate-x-0">
            <StaticImage
              src="../../images/recruit/sale2.JPG"
              alt="中途営業職採用について"
              className="aspect-[2/1] w-full"
            />
          </div>
          <h1 className="mt-16 font-mincho text-3xl text-primary">営業職</h1>
        </div>
        <div className="mt-8">
          <p className="font-gothic leading-loose">
            不燃建材の加工（製作）・販売を行う中で、その販売を担う仕事となります。
            <br />
            時代のニーズがどんどん変化していくなか、今後も需要が増えていくであろう不燃建材。
            <br />
            変化するニーズに応えながら、製品の価値をどのように届けるか。新しい事にチャレンジ出来る方を歓迎します。
          </p>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">職務内容</h2>
          <div className="mt-8 font-gothic">
            <ul className="list-inside list-disc pl-4">
              <li className="my-2">
                お客様（ゼネコン・施工業者など）より製造の発注を頂く為の営業活動　(※飛び込み営業はありません)
              </li>
              <li className="my-2">
                受注後の各工場への製作指示・納品後の請求作業
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">応募条件</h2>
          <div className="mt-8 font-gothic">
            <ul className="list-inside list-disc pl-4">
              <li className="my-2">情熱があり新しい挑戦を楽しめる人 </li>
              <li className="my-2">円滑なコミュニケーションを取れる人</li>
            </ul>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">待遇・制度</h2>
          <div className="mt-8 font-gothic">
            <div class="overflow-x-auto">
              <table class="min-w-full table-auto text-left">
                <tbody class="divide-y divide-transparent">
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      雇用形態
                    </th>
                    <td class="whitespace-nowrap py-2">
                      正社員（試用期間3ヶ月あり）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      勤務地
                    </th>
                    <td class="whitespace-nowrap py-2">
                      東京都新宿区四谷三栄町15-9 寺島ビル3F
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      勤務時間
                    </th>
                    <td class="whitespace-nowrap py-2">9:00〜18:00</td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      時間外労働
                    </th>
                    <td class="whitespace-nowrap py-2">
                      あり（36協定・法定割増に基づき支給）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">給与</th>
                    <td class="whitespace-nowrap py-2">
                      月給220,000円～260,000円（地域手当を含む）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">賞与</th>
                    <td class="whitespace-nowrap py-2">
                      あり （24年度実績 年3回 計5ヶ月以上）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">昇給</th>
                    <td class="whitespace-nowrap py-2">あり （年1回 5月）</td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      各種手当
                    </th>
                    <td class="whitespace-nowrap py-2">
                      役職手当 10,000~50,000円
                      <br />
                      業務手当 10,000~30,000円
                      <br />
                      地域手当 5,000円
                      <br />
                      扶養手当 配偶者 5,000円 こども 3,000円/人
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      休日・休暇
                    </th>
                    <td class="whitespace-nowrap py-2">
                      完全週休2日制（土日）、祝日、GW・夏季・年末年始、有給休暇、その他当社カレンダーによる
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">選考プロセス</h2>
          <div className="mt-8 font-gothic">
            <body>
              <div class="mx-auto">
                <div class="relative my-8">
                  <div class="inline-flex items-center">
                    <span class="inline-block h-4 w-4 rounded-full border border-primary"></span>
                    <span class="pl-4 text-sm text-primary">STEP 1</span>
                  </div>
                  <div class="pl-8">
                    <p class="mt-2 mb-2 font-bold">書類選考</p>
                    <span class="font-gothic">
                      履歴書・職務経歴書を提出いただき、書類を確認いたします。
                    </span>
                  </div>
                  <span class="absolute left-2 top-4 z-[-1] h-[calc(100%+1em)] w-px bg-neutral last:hidden"></span>
                </div>

                <div class="relative my-8">
                  <div class="inline-flex items-center">
                    <span class="inline-block h-4 w-4 rounded-full border border-primary bg-white"></span>
                    <span class="pl-4 text-sm text-primary">STEP 2</span>
                  </div>
                  <div class="pl-8">
                    <p class="mt-2 mb-2 font-bold">面接</p>
                    <span class="font-gothic">
                      採用担当者との面接を行います。
                    </span>
                  </div>
                  <span class="absolute left-2 top-4 z-[-1] h-[calc(100%+1em)] w-px bg-neutral last:hidden"></span>
                </div>

                <div class="relative my-8">
                  <div class="inline-flex items-center">
                    <span class="inline-block h-4 w-4 rounded-full border border-primary ring-2 ring-inset ring-primarySupport"></span>
                    <span class="pl-4 text-sm text-primary">STEP 3</span>
                  </div>
                  <div class="pl-8">
                    <p class="mt-2 mb-2 font-bold">内定</p>
                    <span class="font-gothic">
                      最終結果をご連絡し、条件交渉を経て内定をお知らせします。
                    </span>
                  </div>
                  <span class="absolute left-2 top-4 z-[-1] h-[calc(100%+1em)] w-px bg-neutral last:hidden"></span>
                </div>
              </div>
            </body>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">応募方法</h2>
          <div className="mt-8 font-gothic">
            <p className="font-gothic leading-loose">
              <Link to="/contact" className="underline underline-offset-2">
                お問い合わせフォーム
              </Link>
              よりお名前、ご連絡先を記入の上、「営業職の応募について」とお問い合わせください。
              <br />
              担当者より折り返しご連絡いたします。
            </p>
          </div>
        </div>
      </section>
    </div>
  </Layout>
)

export default Construct
